
import React from 'react';

const EarthUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M16 26c6.62 0 12-5.38 12-12 0-3.45-1.47-6.55-3.81-8.74v-.11l-.14-.01A11.877 11.877 0 0016 2C9.38 2 4 7.38 4 14s5.38 12 12 12zm10-12c0 1.63-.4 3.16-1.09 4.52-.77-.34-1.54-.75-1.72-.94-.17-.3-.39-1.41-.52-5.05l-.01-.29c-.06-1.68-2.11-2.27-3.33-2.63a5.68 5.68 0 01-.3-.09c.06-.33.25-.78.4-.9.16-.1.66-.12 1.07-.13.56-.02 1.2-.05 1.88-.22.57-.15.95-.43 1.21-.76A9.93 9.93 0 0126 14zM13.71 4.27c.22.05.28.13.44.36.07.11.15.22.26.35-.14.14-.38.36-.81.65-.62.42-.94.9-1.22 1.32-.22.32-.39.58-.7.82-.41.33-1.37.7-2.01.95-.82.32-1.16.45-1.4.75-.34.42-.32.99.04 1.81.57 1.25 1.78 2.62 3.48 2.7 1.6.08 2.68.67 3.04.94.15.34.37 1.77-.63 2.81-.73.75-1.86 1.92-2.53 2.38-.21-.81-.37-2.45-.37-3.4 0-.79-.67-1.68-1.75-3.06-.34-.43-.8-1.02-.9-1.23-.33-.7-1.02-1.39-1.47-1.85-.1-.09-.18-.18-.23-.23-.05-.08-.11-.15-.17-.22 1.23-2.91 3.8-5.11 6.93-5.85zm-7.57 8.11c.28.3.57.64.69.89.18.39.55.87 1.14 1.61.44.55 1.24 1.58 1.33 1.83 0 1.47.15 4.94 1.51 5.49.18.07.37.11.56.11 1.11 0 2.35-1.22 4.25-3.18 1.22-1.26 1.35-2.77 1.32-3.56-.01-.35-.1-1.52-.74-2.08-.57-.51-2.13-1.39-4.33-1.5-.75-.04-1.34-.79-1.64-1.34.05-.02.11-.04.16-.06.84-.33 1.89-.73 2.54-1.24.55-.43.86-.9 1.11-1.27.23-.34.39-.58.69-.79 1.2-.82 1.76-1.52 1.82-2.26.03-.37-.09-.73-.33-1.02 2.22.05 4.26.83 5.9 2.1-.05.16-.13.19-.25.22-.47.12-.97.14-1.46.16-.72.03-1.41.06-2.01.42-.84.51-1.38 1.83-1.39 2.78-.01.87.41 1.27.67 1.44.26.16.61.27 1.09.41.43.12 1.73.5 1.89.78l.01.28c.14 4.04.39 5.62 1 6.28.46.5 1.4.99 2.14 1.34A9.965 9.965 0 0116 24c-5.51 0-10-4.49-10-10 0-.55.06-1.09.14-1.62zM26 30H6v2h20v-2z'
			></path>
		</svg>
	);
};

export default EarthUnderline;
